"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
var qr_code_settings_component_1 = require("./settings/qr-code.settings.component");
var idm_de_core_frontend_1 = require("@synisys/idm-de-core-frontend");
var qr_code_content_provider_service_1 = require("../../shared/services/api/qr-code-content-provider.service");
var qrcode_1 = require("qrcode");
var operators_1 = require("rxjs/operators");
var fromPromise_1 = require("rxjs/observable/fromPromise");
var QRCodeComponent = /** @class */ (function () {
    function QRCodeComponent(qrCodeContentProviderService) {
        this.qrCodeContentProviderService = qrCodeContentProviderService;
    }
    QRCodeComponent.prototype.ngOnChanges = function (changes) {
        if (this.imgSource$ && (changes.propertyKey || changes.qrOptions)) {
            this.setImageSource();
        }
    };
    QRCodeComponent.prototype.ngOnInit = function () {
        this.setImageSource();
    };
    QRCodeComponent.prototype.setImageSource = function () {
        var _this = this;
        this.imgSource$ = this.qrCodeContentProviderService.getQRProperties(this.propertyKey, this.category, this.entity)
            .pipe(operators_1.switchMap(function (properties) {
            return fromPromise_1.fromPromise(qrcode_1.toDataURL(properties.content, properties.options || _this.qrOptions || { width: 100 }));
        }));
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", idm_de_core_frontend_1.Entity)
    ], QRCodeComponent.prototype, "entity", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], QRCodeComponent.prototype, "category", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], QRCodeComponent.prototype, "propertyKey", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], QRCodeComponent.prototype, "qrOptions", void 0);
    QRCodeComponent = __decorate([
        core_1.Component({
            selector: 'ejustice-qr-code',
            styles: [require('./qr-code.component.css')],
            changeDetection: core_1.ChangeDetectionStrategy.OnPush,
            template: "<img [src]=\"imgSource$ | async\" alt=\"QR Code\">"
        }),
        idm_dynamic_controls_metadata_1.ControlMetadata({
            cellCount: 12,
            name: 'QR Code',
            groups: [{ 'identity': 'ejustice-qr-code', 'name': 'CMS Controls' }],
            settings: {
                main: qr_code_settings_component_1.QRCodeSettingsComponent,
            },
            template: "<ejustice-qr-code [entity]=\"entity\"\n                                 [category]=\"category\"\n                                 [propertyKey]=\"%{propertyKey}\"\n                                 [qrOptions]=\"%{qrOptions}\"\n                                 ></ejustice-qr-code>"
        }),
        __metadata("design:paramtypes", [qr_code_content_provider_service_1.QRCodeContentProviderService])
    ], QRCodeComponent);
    return QRCodeComponent;
}());
exports.QRCodeComponent = QRCodeComponent;
//# sourceMappingURL=qr-code.component.js.map